/* eslint-disable no-console */
import { TestRunner } from '../TestRunner';

import { assemblerUpgradeTests } from './AssemblerUpgradeTest';
import { basicMiningTests } from './BasicMiningTest';
import { chestCollectionTests } from './ChestCollectionTest';
import { collisionSystemTests } from './CollisionSystemTest';
import { precisionDrillTests } from './PrecisionDrillTest';

// Main test runner entry point
export async function runAllGameTests(): Promise<void> {
  console.log('🎮 FactoryGPT Test Suite');
  console.log('============================\n');

  const runner = new TestRunner();

  // Add all test suites
  console.log('📝 Registering test suites...');

  const suites = [
    { name: 'Basic Mining', tests: basicMiningTests },
    { name: 'Chest Collection', tests: chestCollectionTests },
    { name: 'Collision System', tests: collisionSystemTests },
    { name: 'Precision Drill', tests: precisionDrillTests },
    { name: 'Assembler Upgrades', tests: assemblerUpgradeTests },
  ];

  let totalTests = 0;

  for (const suite of suites) {
    console.log(` - ${suite.name}`);
    for (const test of suite.tests) {
      runner.addTest(test);
      totalTests += 1;
      console.log(`   + ${test.name}`);
    }
  }

  console.log(`\n✅ Registered ${totalTests} tests\n`);

  // Run all tests
  const results = await runner.runAllTests();

  // Return exit code for CI/automated testing
  const failedTests = results.filter(r => !r.passed).length;
  if (failedTests > 0) {
    console.log(`\n💥 ${failedTests} test(s) failed. Exit code: 1`);
    if (typeof process !== 'undefined' && process.exit) {
      process.exit(1);
    }
  } else {
    console.log('\n🎉 All tests passed. Exit code: 0');
    if (typeof process !== 'undefined' && process.exit) {
      process.exit(0);
    }
  }
}

// Export individual test suites for selective testing
export { basicMiningTests } from './BasicMiningTest';
export { chestCollectionTests } from './ChestCollectionTest';
export { collisionSystemTests } from './CollisionSystemTest';
export { precisionDrillTests } from './PrecisionDrillTest';
export { assemblerUpgradeTests } from './AssemblerUpgradeTest';
export { TestRunner, TestWorld } from '../TestRunner';

// Auto-run tests if this file is executed directly
if (typeof require !== 'undefined' && require.main === module) {
  runAllGameTests().catch(console.error);
}
